import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class GenderSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'Seleccionar Género' },
            { value: 'MALE', label: 'Masculino' },
            { value: 'FEMALE', label: 'Femenino' }
        ];
        return (
            <OgaSelect
                bsSize="large"
                placeholder="Género"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GenderSelect/GenderSelect.jsx